import React, {useEffect, useMemo, useRef, useState} from 'react';
import {connect} from "react-redux";
import { List } from 'react-virtualized';
import 'react-virtualized/styles.css';

import {getCurrentLayout} from "../../../../../../../appLayout";
import {getNavItems} from "../../../../../../helpers/sqftHelperUi";
import PropTypes from "prop-types";
import {featureInterface} from "../../../../../../../../interfaces/featureInterface";
import SqftFeaturesChecker from "./SqftFeaturesChecker";
import SqftOptionsLoading from "./SqftOptionsLoading";
import SqftOptionsRelatedItemRow from "./SqftOptionsRelatedItemRow";
import {getFilteredRelatedFeatures, getRelatedFeaturesFromLayout} from "../../../../../../../../misc/helpers";
import uniqBy from "lodash/uniqBy";
import {getSortedFeatures} from "../../../../../../helpers/featureHelper";

const SqftOptionsRelatedItemList = (props) => {
  const {windowHeight, isMobile} = props;
  const {activeFeature, itemClickCallback, partId, shouldSortByWidth, searchInputValue} = props;
  const [activeItemIndex, setActiveItemIndex] = React.useState(0);
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [listWidth, setListWidth] = useState(296);

  useEffect(() => {
    setListWidth(isMobile ? 238 : 296);
  }, [isMobile]);

  useEffect(() => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.clientHeight); // Вычисляем и сохраняем высоту контейнера
    }
  }, [windowHeight]);

  const layout = useMemo(() => getCurrentLayout(), []);
  const featureGroup = useMemo(() => layout.getFeatureGroupByPartId(partId), [layout, partId]);

  const [loading, setLoading] = useState(featureGroup ? !featureGroup.allFeaturesReceived : false);
  useEffect(() => {
    setLoading(featureGroup ? !featureGroup.allFeaturesReceived : false)
  }, [featureGroup]);

  let {featuresMatchedByName, parentFeature} = useMemo(() => {
    let activeFeatureName;
    let parentFeature;
    if (featureGroup && featureGroup.activeFeature) {
      activeFeatureName = featureGroup.activeFeature.getFeatureName();
      parentFeature = featureGroup.activeFeature;
    // } else if (activeFeature) {
    //   activeFeatureName = activeFeature.getFeatureName()
    } else if (featureGroup) {
      const layout = getCurrentLayout();
      const navItems = layout.designNavigationItems({part: featureGroup});
      console.log("featureGroup navItems", navItems);
      console.log("no features in featureGroup", featureGroup.partId);
      return {activeFeatureName: null, parentFeature: null }
    } else {
      return {activeFeatureName: null, parentFeature: null }
    }

    let featuresMatchedByName = getNavItems({ part: featureGroup }, activeFeatureName, true, true);
    if (featuresMatchedByName.length === 0 && featureGroup.activeFeature) {
      featuresMatchedByName = layout.designNavigationItems({part: featureGroup},
        [],
        activeFeatureName,
        featureGroup.activeFeature,
        "all",
        [],
        { firstFeature: null, firstConditions: null},
      );
    }

    return {featuresMatchedByName, parentFeature};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFeature, featureGroup, partId]);

  if (!featureGroup) {
    return <SqftOptionsLoading windowHeight={windowHeight} isMobile={isMobile}/>
  }

  if (featuresMatchedByName.length === 0) {
    console.log("selected feature matched by name not found", partId);
    console.log("activeFeature", activeFeature);
    return null
  }

  if (!featuresMatchedByName[0].part.dbFeature.relatedFeatures) {
    console.log("relatedFeatures are missing", featuresMatchedByName[0].part.dbFeature.relatedFeatures);
    console.log("featuresMatchedByName[0]", featuresMatchedByName[0]);
    return null
  }
  const {noFeaturesFound, relatedFeaturesFound} = getRelatedFeaturesFromLayout(featuresMatchedByName[0].part.dbFeature.relatedFeatures, featuresMatchedByName[0].part, searchInputValue);
  void noFeaturesFound;

  // Filter unique and missing thirdPartyAR3DUrls features
  let relatedItemsList = getFilteredRelatedFeatures(relatedFeaturesFound);
  relatedItemsList = uniqBy(relatedItemsList, (feature) => feature.dbFeature.id);
  let emptyUrlsLog = [];

  // Filter relatedItemsList
  relatedItemsList = relatedItemsList.filter(feature => {
    if (!feature.dbFeature.thirdPartyAR3DUrls) {
      // Add the sharedFeatureName to the array
      emptyUrlsLog.push(feature.dbFeature.sharedFeatureName);
    } else {
      return feature;
    }
  });

  // If there are any names in the array, log them
  if (emptyUrlsLog.length > 0) {
    console.log(`Features with empty thirdPartyAR3DUrls: ${emptyUrlsLog.join(', ')}`);
  }

  // Sort features by width
  if (shouldSortByWidth) {
    relatedItemsList = getSortedFeatures(relatedItemsList);
  }

  return (
    <div className="side-level2__content" ref={containerRef}>
      {loading
        ? <SqftFeaturesChecker subPart={featureGroup} callBack={() => setLoading(false)}/>
        :
        // featuresMatchedByName[0].part.dbFeature.relatedFeatures.map((feature, index) => {
        //   return <SqftOptionsRelatedItemRow
        //     key={index}
        //     index={index}
        //     feature={feature}
        //     featuresMatchedByName={featuresMatchedByName}
        //     activeItemIndex={activeItemIndex}
        //     setActiveItemIndex={setActiveItemIndex}
        //     itemClickCallback={itemClickCallback}
        //     />
        // })
        <List
          width={listWidth} // Измените на ширину вашего контейнера
          height={containerHeight} // Можно использовать высоту окна или контейнера
          rowCount={relatedItemsList.length}
          rowHeight={135} // Измените в соответствии с высотой элемента
          rowRenderer={({ key, index, style }) => (
            <SqftOptionsRelatedItemRow
              key={key}
              style={style}
              partId={partId}
              feature={relatedItemsList[index]}
              parentFeature={parentFeature}
              activeItemIndex={activeItemIndex}
              setActiveItemIndex={setActiveItemIndex}
              itemClickCallback={itemClickCallback}
              //onClick={() => handleItemClick(features[index], index)}
            />
          )}
        />
      }
    </div>
  )
};

SqftOptionsRelatedItemList.propTypes = {
  activeFeature: PropTypes.shape(featureInterface),
  partId: PropTypes.string,
  shouldSortByWidth: PropTypes.bool,
  itemClickCallback: PropTypes.func,
  searchInputValue: PropTypes.string
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {visualizersLoaded} = store.serverState;
  const {windowHeight, isMobile} = store.serverState;

  return {
    menuOpened,
    windowHeight,
    isMobile,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftOptionsRelatedItemList);
